import React, { useEffect, useState } from 'react';
import 'react-calendar/dist/Calendar.css';
import './index.css';
import { dateStrToObj, dateIsValid, dateObjToStr } from '../../../utils/date';
import { useTranslation } from 'react-i18next';
import Input, { InputProps } from '../../atoms/input';
import Calendar from 'react-calendar';
import classNames from 'classnames';
import { getLocale } from '../../../lib/locale';

interface InputCalendarProps extends InputProps {
	date?: Date;
	onDateChange?: (date: Date) => void;
}

const InputCalendar = ({
	date,
	onDateChange,
	...props
}: InputCalendarProps) => {
	const [input, setInput] = useState<string | undefined>();
	const [isVisible, setIsVisible] = useState<boolean>(false);

	const locale = getLocale();

	useEffect(() => {
		if (input && dateIsValid(input))
			onDateChange?.(dateStrToObj(input, locale));
	}, [input]);

	useEffect(() => {
		if (date) setInput(dateObjToStr(date));
		else setInput('');
	}, [date]);

	const handleInput = (e: React.ChangeEvent<HTMLInputElement>) =>
		setInput(e.target.value);

	const handleDayClick = (newDate?: Date) => {
		if (!newDate) return;
		setIsVisible(false);
		onDateChange?.(newDate);
		setInput(dateObjToStr(newDate));
	};

	return (
		<div className="h-fit">
			<Input
				value={input || ''}
				onChange={handleInput}
				mask="99/99/9999"
				icon="Calendar"
				iconContainerClassName="rounded-full cursor-pointer transition-colors bg-transparent hover:bg-gray-bg *:hover:fill-primary"
				onIconClick={() => setIsVisible(!isVisible)}
				{...props}
			/>
			<Calendar
				className={classNames({
					block: isVisible,
					hidden: !isVisible,
				})}
				value={date}
				locale={locale}
				calendarType="gregory"
				onClickDay={handleDayClick}
			/>
		</div>
	);
};

export default InputCalendar;
